<template>
  <div>
    <Modal v-model="isDetail" :title="title" :footer-hide="true">
      <Form :label-width="80" v-if="mode=='edit'">
        <FormItem label="父角色">
          <!--<Select v-model="formData.PGID">
            <Option :value="item.GID" v-for="(item, index) in roleList" :key="index">
              {{item.GroupName}}
            </Option>
          </Select>-->
          <vue-treeselect v-model="formData.PGID" :options="selectTree" />
        </FormItem>
        <FormItem label="角色ID" v-if="isDebug">{{ formData.GID }}</FormItem>
        <FormItem label="角色Key">
          <Input placeholder v-model="formData.RoleKey" />
        </FormItem>
        <FormItem label="角色名">
          <Input placeholder v-model="formData.GroupName" />
        </FormItem>
        <FormItem>
          <Button type="primary" :loading="loading" @click="editRole()" style="width:100%">
            <span v-if="!loading">保存</span>
            <span v-else>保存中...</span>
          </Button>
        </FormItem>
      </Form>

      <Form :label-width="80" v-if="mode=='append'">
        <FormItem label="父角色ID" v-if="isDebug">{{formData.PGID}}</FormItem>
        <FormItem label="父角色名">{{formData.PGroupName}}</FormItem>

        <FormItem label="子角色名">
          <Input placeholder v-model="formData.GroupName" />
        </FormItem>
        <FormItem>
          <Button type="primary" :loading="loading" @click="addSubRole()" style="width:100%">
            <span v-if="!loading">保存</span>
            <span v-else>保存中...</span>
          </Button>
        </FormItem>
      </Form>

      <Form :label-width="80" v-if="mode=='create'">
        <FormItem label="角色名">
          <Input placeholder v-model="formData.GroupName" />
        </FormItem>
        <FormItem>
          <Button type="primary" :loading="loading" @click="createRole()" style="width:100%">
            <span v-if="!loading">保存</span>
            <span v-else>保存中...</span>
          </Button>
        </FormItem>
      </Form>

    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    AllRoleList: Array
  },
  data() {
    return {
      isDetail: false,
      loading: false,
      title: "",
      isDebug: false, //是否显示ID,专门用来调试
      mode: null,
      oldrolelist: [],
      formData: {
        PGID: "-",
        PGroupName: ""
      },
      roleList: [],
      saveOkFn: null
    };
  },
  computed: {
    selectTree() {
      let _this = this;

      return _this.roleList.List2Tree("GID", "PGID", (src, sublist) => {
        let item = {};
        item.id = src.GID;
        item.label = src.GroupName;
        item.children = sublist;
        return item;
      });
    }
  },
  methods: {
    createRole() {
      let _this = this;
      let { GroupName, RoleKey } = this.formData;

      _this.loading = true;
      let res = { PGID: null, GroupName, GID: new Date().getTime(), RoleKey };

      return setTimeout(() => {
        _this.isDetail = false;
        if (_this.saveOkFn) {
          _this.saveOkFn(res);
        }
        _this.loading = false;
      }, 500);
    },
    addSubRole() {
      let _this = this;
      let { PGID, GroupName, RoleKey } = this.formData;
      _this.loading = true;
      let res = {
        PGID,
        GroupName,
        GID: JSON.stringify(new Date().getTime()),
        RoleKey
      };

      return setTimeout(() => {
        _this.isDetail = false;
        if (_this.saveOkFn) {
          _this.saveOkFn(res);
        }
        _this.loading = false;
      }, 500);
    },
    editRole() {
      let _this = this;
      let { GID, GroupName, PGID, RoleKey } = this.formData;
      // 把表单的信息 传回给后台

      let res = { GID, PGID, GroupName, RoleKey };
      let newKey = Object.assign({}, true, this.formData);
      let findobj = _this.oldrolelist.find(
        a => a.RoleKey === newKey.RoleKey && a.GID != GID
      );
      if (findobj) {
        this.$Message.error("Key已重复，在" + findobj.GroupName);
        return;
      }

      _this.loading = true;
      return setTimeout(() => {
        if (_this.saveOkFn) {
          _this.saveOkFn(res);
          _this.isDetail = false;
        }

        _this.loading = false;
      }, 500);
    },
    ShowCreateDlg(opts) {
      let _this = this;
      let { rowData, title, saveOkFn } = opts;
      _this.mode = "create";
      _this.isDetail = true;
      _this.title = title;
      _this.saveOkFn = saveOkFn;
      _this.formData = Object.assign({}, true, rowData);
    },
    ShowAppendDlg(opts) {
      //子节点添加
      let _this = this;
      let { rowData, title, saveOkFn } = opts;
      _this.mode = "append";
      _this.isDetail = true;
      _this.title = title;
      _this.saveOkFn = saveOkFn;
      _this.formData = Object.assign({}, true, rowData);
    },
    ShowEditDlg(opts) {
      //编辑
      let _this = this;
      let { rowData, title, saveOkFn, oldrolelist, oldKey } = opts;
      // , saveErrFn
      _this.oldrolelist = oldrolelist; //原来的rolelist
      _this.mode = "edit";
      _this.isDetail = true;
      _this.title = title;
      _this.saveOkFn = saveOkFn; //用于成功回调的函数
      // _this.saveErrFn = saveErrFn; //用失败回调的函数
      _this.formData = Object.assign({}, true, rowData); //拷贝一份rowData
      _this.roleList = _this.AllRoleList.filter(p => p.GID != rowData.GID);
      // // console.log(_this.roleList) //拿到一个点击编辑按钮的对象 和  GID: "all",
      // // GroupName: "无" 新建对象 的数组   （这是下拉框的内容）
      _this.roleList.unshift({
        GID: "all",
        PGID: null,
        GroupName: "无"
      });
    },
    ShowCreateRoleTypeDlg(opts) {
      let _this = this;
      let { saveOkFn, rowData } = opts;
      _this.mode = "createroletype";
      _this.isDetail = true;
      _this.title = "新建角色类别";
      _this.saveOkFn = saveOkFn;
      _this.formData = Object.assign({}, true, rowData);
    }
  }
};
</script>

